import { Button } from 'reactstrap';
const { default: styled } = require('styled-components');

const ModalContent = styled.div`
  padding: 1.5rem;
`;

const Description = styled.p`
  margin-bottom: 1.5rem;
  color: #6c757d;
  line-height: 1.6;
  font-size: 0.95rem;
`;

const MappingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FieldSelectionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
`;

const FieldGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`;

const FieldLabel = styled.label`
  font-weight: 600;
  font-size: 0.875rem;
  color: #495057;
  margin-bottom: 0.25rem;
  white-space: nowrap;
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  margin-top: 1.5rem;
  color: #6c757d;
  transition: color 0.2s ease;

  &:hover {
    color: #495057;
  }

  @media (max-width: 768px) {
    transform: rotate(90deg);
    margin: 0.5rem 0;
    padding: 0.5rem 0;
  }
`;

const PreviewSection = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f1f3f5 100%);
  border-radius: 0.5rem;
  padding: 1.25rem;
  border: 1px solid #d1d9e0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
`;

const ActionSection = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1.25rem;
  border-top: 1px solid #e9ecef;
  margin-top: 0.5rem;
`;

const StyledButton = styled(Button)`
  padding: 0.625rem 2rem;
  font-weight: 500;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 150px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    transform: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SelectWrapper = styled.div`
  position: relative;

  .flex-select-container {
    border-radius: 0.375rem;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &:focus-within {
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
  }
`;

export {
  ModalContent,
  Description,
  MappingContainer,
  FieldSelectionWrapper,
  FieldGroup,
  FieldLabel,
  ArrowContainer,
  PreviewSection,
  ActionSection,
  StyledButton,
  SelectWrapper
};
